import styled from 'styled-components';

import { media, Z_INDEX_SIDE_BAR } from '@savgroup-front-common/constants';

import { rem } from '../../helpers';

import { DrawerPosition } from './Drawer.types';

interface $SideBarContainerProps {
  $widths: number[];
  $width: number;
  $withPadding: boolean;
  $position: DrawerPosition;
}

const calc = ($widths: number[], $current: number) => {
  const initial = $widths.length
    ? $current - $current / (2 * $widths.length)
    : 0;

  const total = $widths.reduce<number>((acc, current, index) => {
    const decelerate = index > 0 ? 2 * index : 1;
    const next = current / decelerate;

    return acc + next;
  }, -initial);

  return rem(total);
};

export const $DrawerContainer = styled.div<$SideBarContainerProps>`
  @media ${media.maxWidth.xs} {
    width: 100vw;
  }
  width: ${({ $width }) => rem($width)};
  max-width: 100%;
  padding: ${({ $withPadding }) => ($withPadding ? '1.5rem' : null)};

  height: 100vh;
  background: ${({ theme }) => theme.colors.white};
  overflow-y: auto;
  transform: translate3d(
    ${({ $widths, $width }) => calc($widths, $width)},
    0,
    0
  );
  transition-duration: 0.2s;
`;

export const $BlockContainer = styled.div<{ $position: DrawerPosition }>`
  position: fixed;
  z-index: ${Z_INDEX_SIDE_BAR};
  top: 0;
  left: ${({ $position }) => ($position === DrawerPosition.Left ? '0' : null)};
  right: ${({ $position }) =>
    $position === DrawerPosition.Right ? '0' : null};
`;
